import type {
  AddOrgFunctionRequest,
  OrgFunctionKind,
  UpdateOrgFunctionRequest
} from '@bliks-io/contracts';
import { useCreateOrgFunction } from '@/api/mutations/useOrgFunctions';
import { OrgFunctionFormDialog } from '@/pages/organization/org-functions/components/OrgFunctionFormDialog';

export interface OrgFunctionCreateDialogProps {
  /** Fixed by the picker pane that opened the dialog — teams pane → team. */
  kind: OrgFunctionKind;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialName: string;
  /** Fires once the created entity is visible to the picker's list query. */
  onCreated: (id: string) => void;
}

export function OrgFunctionCreateDialog({
  kind,
  open,
  onOpenChange,
  initialName,
  onCreated
}: OrgFunctionCreateDialogProps) {
  const createMutation = useCreateOrgFunction();

  // A rejected create propagates to FormDialog, which keeps the dialog open
  // and shows the error; this dialog only ever creates.
  const handleSubmit = async (data: AddOrgFunctionRequest | UpdateOrgFunctionRequest) => {
    const result = await createMutation.mutateAsync(data as AddOrgFunctionRequest);
    onCreated(result.data._id);
    onOpenChange(false);
  };

  return (
    <OrgFunctionFormDialog
      open={open}
      onOpenChange={onOpenChange}
      kind={kind}
      defaultValuesOverride={{ name: initialName }}
      onSubmit={handleSubmit}
    />
  );
}
